import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { FormLabel, Input, Text, FormControl, FormErrorMessage, InputRightAddon, InputGroup, Stack, InputLeftAddon, Image } from '@chakra-ui/react';
import { images } from '../support/imageSupport';


export interface InputParams {
    id: string
    name: string
    title: string
    message: string | null
    disabled: boolean
    value: string
    placeholder?: string
    addOnRight?: string
    addOnLeft?: string
    body?: string
    type: 'tel' | 'email' | 'text' | 'number'
    visible?: boolean
}

interface InputProps {
    id: string
    title: string
    name: string
    message: string | null
    value: string
    body?: string
    help?: string
    disabled: boolean
    placeholder?: string
    addOnRight?: string
    addOnLeft?: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void
    type: 'tel' | 'email' | 'text' | 'number'
    visible?: boolean

}


const BtInput: FunctionComponent<InputProps> = ({ id, name, message, value, onChange, body, disabled, placeholder, addOnRight, addOnLeft, title, type, visible, onFocus }) => {
    const [cursor, setCursor] = useState<number | null>(null);
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const input = ref.current;
        if (input !== null && input.type !== 'number' && input.type !== 'email') input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };




    const handleOnfocus = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onFocus) {
            onFocus(e)
        }
    }
    return (<>
        {visible !== false && <FormControl isInvalid={message !== ''} isDisabled={disabled}>
            <FormLabel htmlFor={id}>{title}</FormLabel>
            {addOnRight !== undefined && <Stack spacing={4}>
                <InputGroup size='md'>
                    <Input ref={ref} type={type} variant='filled' _focus={{ color: 'black', bg: 'white' }} id={id} name={name} onChange={(event) => handleChange(event)} value={value} disabled={disabled} placeholder={placeholder} onFocus={(e) => handleOnfocus(e)} />
                    <InputRightAddon children={addOnRight} />
                </InputGroup>
            </Stack>}

            {addOnLeft !== undefined && <Stack spacing={4}>
                <InputGroup size='md'>
                    <InputLeftAddon children={<Image src={images(addOnLeft)} />} />
                    <Input ref={ref} type={type} variant='filled' _focus={{ color: 'black', bg: 'white' }} id={id} name={name} onChange={(event) => handleChange(event)} value={value} disabled={disabled} placeholder={placeholder} onFocus={(e) => handleOnfocus(e)} />
                </InputGroup>
            </Stack>}

            {addOnRight === undefined && addOnLeft === undefined &&
                <Input ref={ref} type={type} variant='filled' _focus={{ color: 'black', bg: 'white' }} id={id} name={name} onChange={(event) => handleChange(event)} value={value} disabled={disabled} placeholder={placeholder} onFocus={(e) => handleOnfocus(e)} />
            }
            <FormErrorMessage>{message}</FormErrorMessage>
            <Text>{body}</Text>
        </FormControl >}

    </>
    )

}

export default BtInput;